import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const GameScoreServices = {
  uploadGameScoreDocument,
  getUploadedDocument,
  insertCounterMovements,
  getUploadedPHADocuments,
  savePlayerDexaBodyFatDocuments,
  getDexaBodyFatUrlByDocID,
};

async function uploadGameScoreDocument(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_GAME_SCORE_DOCUMENT}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getUploadedDocument(eventId, sDocType) {
  const response = await APIHelper.get(
    APIURLConstants.GET_GAME_SCORE_UPLOADED_DOCUMENTS(eventId, sDocType),
    authHeader()
  );
  return response;
}

async function insertCounterMovements(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_COUNTER_MOVEMENTS}`,
    formObj,
    authHeader()
  );
  return response;
}

async function savePlayerDexaBodyFatDocuments(details) {
  const response = await APIHelper.post(
    `${APIURLConstants.SAVE_PLAYER_DEXABODYFAT_DOCUMENTS}`,
    details,
    authHeader()
  );
  return response;
}

async function getDexaBodyFatUrlByDocID(docId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_DEXABODYFAT_URL_BY_ID(docId),
    authHeader()
  );
  return response;
}

async function getUploadedPHADocuments(eventId, sDocType, playerID, stationID) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_GAME_SCORE_UPLOADED_DOCUMENTS(
      eventId,
      sDocType
    )}?StationId=${stationID}&PlayerID=${playerID}`,
    authHeader()
  );
  return response;
}
